import { Box, BoxProps, ColorOptions, convertHexToRGBA, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/utils'
import { useNavigation, useRoute } from '@react-navigation/native'
import { FC, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Pressable, ScrollView, View, ViewProps } from 'react-native'
import EmptyView from '../../../../comps/EmptyView'
import { SvgImage } from '../../../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../../../data/store'
import { Routes } from '../../../../nav/routes'
import { Colors, isMobile, logEvent } from '../../../../util/util'
import { getFullName, getProfileLabel, isAnyChecked } from '../Helper'
import { Delete } from './Delete'
import { ModelBlockUser } from './ModelBlockUser'
import { UserDetailList } from './UserDetailList'
import { Platform } from 'react-native'

const ViewUserDetail: FC = () => {
  const editData: any = useRoute()?.params
  const { user } = editData
  const { deleteUserApi, blockUnblockUserApi, mid, getPermissionList, getUserOptedPermissions } = useStores(
    (store) => ({
      deleteUserApi: store.userManagement.deleteUserApi,
      blockUnblockUserApi: store.userManagement.blockUnblockUserApi,
      mid: store.user.selectedMid,
      getPermissionList: store.userManagement.getUserPermissions,
      getUserOptedPermissions: store.userManagement.getUserOptedPermissions,
    }),
  )

  const [deleteUser, deleteUserHandler] = useLazyApiData(deleteUserApi)
  const [blockUnblockUser, blockUnblockUserHandler] = useLazyApiData(blockUnblockUserApi)
  const [getUserPermissions, userPermissionHandler] = useLazyApiData(getPermissionList)
  const [userData]: any = useState(user)
  const [showModal, setShowModal]: any = useState(false)
  const [action, setAction]: any = useState('')
  const [showBlockUserModel, setShowBlockUserModel]: any = useState(false)
  const [successAction, setSuccessAction] = useState('')
  const navigation = useNavigation()
  const isLargeScreen = useIsLargeScreen()
  const isMob = isMobile(isLargeScreen)
  const postData = {
    jfsUserId: userData.jfsUserId,
    entityId: mid,
  }

  useEffect(() => {

    if (userData.status != 'TERMINATED')
    {
        navigation.setOptions({
        gestureEnabled: true,
        headerStyle: { height: 64 },
        headerShadowVisible: false,
        headerRight: () => (
          <Box flexDirection={'row'} align="center" pr={20}>
            <View style={styles.scaleEdit}>
              <Pressable onPress={userNavigation} testID="edit-user" disabled={userData.status === 'TERMINATED'}>
                <SvgImage imageName="EditIcon" color={'#fff'} />
              </Pressable>
            </View>
            <Spacer size={24} direction="horizontal" />
            <Box onPress={() => setShowModal(true)} underlayColor="TRANSPARENT" testID="miew-more-option">
              <SvgImage imageName="MoreIcon" width={24} height={24} color={'#fff'} />
            </Box>
          </Box>
        ),
        title: '',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation])

  useEffect(() => {
    if (deleteUserHandler.state === 'fulfilled' || blockUnblockUserHandler.state === 'fulfilled') {
      setShowBlockUserModel(false)
      getUserPermissions(postData, isMob, false)
      setSuccessAction('SUCCESS')
      // navigation.navigate(Routes.USER_MANAGEMENT.VIEW_USERS as never)

      navigation.popTo(Routes.USER_MANAGEMENT.VIEW_USERS as never)
    }
    if (deleteUserHandler.state === 'rejected' || blockUnblockUserHandler.state === 'rejected') {
      console.log('error')
      setShowBlockUserModel(false)
      setSuccessAction('ERROR')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteUserHandler.state, blockUnblockUserHandler.state, showBlockUserModel, showModal])

  useLayoutEffect(() => {
    getUserPermissions(postData, isMob, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.jfsUserId, getUserPermissions, mid])

  const userOptedAccessRights = getUserOptedPermissions()
  const { state } = userPermissionHandler
  const isLoading = state === 'pending'
  const errorState = userPermissionHandler?.data?.messsage ?? false
  const emptyMessage =
    userPermissionHandler.state !== 'fulfilled' && userPermissionHandler?.data?.length === 0
      ? 'Something went wrong'
      : ''

  const userNavigation = () => {
    logEvent('header_menu_pressed', 'open_edit_user')
    const modifiedData = {
      id: userData?.jfsUserId,
      name: getFullName(userData),
      mobileNo: userData?.user?.mobile?.mobileNumber ?? '',
      email: userData?.email,
      department: userData?.department,
    }
    //console.log('data nav', modifiedData)
    navigation.navigate(
      Routes.USER_MANAGEMENT.EDIT_USER_ROLE_MOBILE as never,
      { user: modifiedData, userData } as never,
    )
  }

  const blockUser = (type: String) => {
    if (type === 'BLOCK' || action === 'UNBLOCK') {
      blockUnblockUser(userData.id, mid, type.toLowerCase())
    } else if (type === 'DELETE') {
      deleteUser(userData.id, mid, 'delete')
    }
  }

  const onDissMiss = () => {
    setShowModal(true)
    setShowBlockUserModel(false)
  }

  const handleAction = (action: string) => {
    logEvent('btn_press', `${action.toLocaleLowerCase()}_user`)
    setAction(action)
    setShowModal(false)
    setShowBlockUserModel(true)
  }

  const fullName: any = getFullName(userData)
  const profileLabel: any = getProfileLabel(userData)
  // console.log('fullName', fullName, userData?.user.name)
  if (showBlockUserModel && Platform.OS === 'ios')
  {
      return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ScrollView style={styles.listWrapper} showsVerticalScrollIndicator={false}>
        <ModBox show={!isLoading && !errorState && !emptyMessage}>
          <Box flexDirection={'row'} justifyContent="space-between">
            <Box>
              <Box width={53} height={53} borderRadius={53} bg={'SECONDARY'} align="center" justify="center">
                {!profileLabel ? (
                  <Box {...({ transform: [{ scale: 0.8 }] } as BoxProps)}>
                    <SvgImage imageName="ProfileIcon" color={Colors.WHITE} />
                  </Box>
                ) : (
                  <Text fontFamily={'JioType-Bold'} fontSize={16} color={'WHITE'}>
                    {profileLabel ? profileLabel : 'NA'}
                  </Text>
                )}
              </Box>
              <Spacer size={20} direction="vertical" />
              <Box>
                <Text fontFamily={'JioType-Bold'} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
                  {fullName ? fullName : 'NA'}
                </Text>
                <Spacer size={5} direction="vertical" />
                <Box flexDirection={'row'} align="center">
                  <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                    +{userData?.user?.mobile?.countryCode} {userData?.user?.mobile?.mobileNumber}
                  </Text>
                  <ModBox show={user?.department} flexDirection={'row'} align="center">
                    <Spacer size={4} direction="horizontal" />
                    <Box width={5} height={5} borderRadius={5} backgroundColor={'#B5B5B5' as ColorOptions} />
                    <Spacer size={6} direction="horizontal" />
                    <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                      {user?.department}
                    </Text>
                  </ModBox>
                </Box>
                <ModBox show={user?.lastLogin} flexDirection={'row'} align="center" pt={8}>
                  <SvgImage imageName="TimerIcon" color={Colors.SECONDARY} />
                  <Spacer size={6} direction="horizontal" />
                  <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                    Last Login:
                  </Text>
                  <Text color={Colors.BLACK_14 as ColorOptions} fontFamily={'JioType-Medium'} fontSize={14}>
                    {user?.lastLogin}
                  </Text>
                </ModBox>
              </Box>
            </Box>
            <Box height={23} justify="center" ph={6} borderRadius={6} {...styles?.textColorStatus(user?.status)}>
              <Text fontFamily={'JioType-Bold'} color={'WHITE'} fontSize={12}>
                {user?.status === 'TERMINATED' ? 'DELETED' : user?.status}
              </Text>
            </Box>
          </Box>
          <Spacer size={32} direction="vertical" />
          <Box height={1} bg={convertHexToRGBA('#000', 12) as ColorOptions} />
          <Spacer size={24} direction="vertical" />

          <UserDetailList item={userData} />

          <Spacer size={32} direction="vertical" />
          <Box
            borderRadius={8}
            borderWidth={1}
            borderColor={convertHexToRGBA(Colors.PRIMARY, 24) as ColorOptions}
            pv={16}
            ph={15}
            backgroundColor={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
            <Text
              fontFamily={'JioType-Bold'}
              color={Colors.BLACK_14 as ColorOptions}
              fontSize={14}
              lineHeight={24}
              letterSpacing={-0.07}>
              Permissions
            </Text>
            <Spacer direction="vertical" size={14} />
            <Box flexDirection={'row'} flexWrap={'wrap'}>
              {userOptedAccessRights?.map((item: any, index: number) => {
                return (
                  <Box key={index} width={'50%'} flexDirection="row" pv={8}>
                    <SvgImage imageName={isAnyChecked(item.data) ? 'ItemChecked' : 'ItemUnChecked'} />
                    <Spacer size={5} direction="horizontal" />
                    <Text fontFamily={'JioType-Medium'} color={Colors.BLACK_14 as ColorOptions} fontSize={12}>
                      {item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous'}
                    </Text>
                  </Box>
                )
              })}
            </Box>
          </Box>
          <Spacer direction="vertical" size={50} />
        </ModBox>

        <ModalDialogNew animate={true} show={showModal} type="bottom" backgroundColor="TRANSPARENT">
          <Delete onPressItem={handleAction} status={userData.status} onDissMiss={() => setShowModal(false)} />
        </ModalDialogNew>

        <ModelBlockUser
          show={showBlockUserModel}
          onDismiss={onDissMiss}
          onPressDone={blockUser}
          data={userData}
          action={action}
          isLoading={deleteUserHandler.state === 'pending' || blockUnblockUserHandler.state === 'pending'}
          status={successAction}
        />
      </ScrollView>
    </Box>
  )
  }
  else
  {
    return (
    <Box flex={1} backgroundColor="SECONDARY">
      <ScrollView style={styles.listWrapper} showsVerticalScrollIndicator={false}>
        {isLoading && (
          <ModBox justifyContent={'center'} flex={1}>
            <EmptyView
              testID="empty_view"
              onRetry={() => console.log('Retry')}
              isLoading={isLoading}
              error={errorState}
              emptyMessage={emptyMessage}
              loadingMessage="Fetching Users..."
              hide={!isLoading && !errorState && !emptyMessage}
            />
          </ModBox>
        )}
        <ModBox show={!isLoading && !errorState && !emptyMessage}>
          <Box flexDirection={'row'} justifyContent="space-between">
            <Box>
              <Box width={53} height={53} borderRadius={53} bg={'SECONDARY'} align="center" justify="center">
                {!profileLabel ? (
                  <Box {...({ transform: [{ scale: 0.8 }] } as BoxProps)}>
                    <SvgImage imageName="ProfileIcon" color={Colors.WHITE} />
                  </Box>
                ) : (
                  <Text fontFamily={'JioType-Bold'} fontSize={16} color={'WHITE'}>
                    {profileLabel ? profileLabel : 'NA'}
                  </Text>
                )}
              </Box>
              <Spacer size={20} direction="vertical" />
              <Box>
                <Text fontFamily={'JioType-Bold'} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
                  {fullName ? fullName : 'NA'}
                </Text>
                <Spacer size={5} direction="vertical" />
                <Box flexDirection={'row'} align="center">
                  <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                    +{userData?.user?.mobile?.countryCode} {userData?.user?.mobile?.mobileNumber}
                  </Text>
                  <ModBox show={user?.department} flexDirection={'row'} align="center">
                    <Spacer size={4} direction="horizontal" />
                    <Box width={5} height={5} borderRadius={5} backgroundColor={'#B5B5B5' as ColorOptions} />
                    <Spacer size={6} direction="horizontal" />
                    <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                      {user?.department}
                    </Text>
                  </ModBox>
                </Box>
                <ModBox show={user?.lastLogin} flexDirection={'row'} align="center" pt={8}>
                  <SvgImage imageName="TimerIcon" color={Colors.SECONDARY} />
                  <Spacer size={6} direction="horizontal" />
                  <Text color="PRIMARY_GREY" fontFamily={'JioType-Medium'} fontSize={14}>
                    Last Login:
                  </Text>
                  <Text color={Colors.BLACK_14 as ColorOptions} fontFamily={'JioType-Medium'} fontSize={14}>
                    {user?.lastLogin}
                  </Text>
                </ModBox>
              </Box>
            </Box>
            <Box height={23} justify="center" ph={6} borderRadius={6} {...styles?.textColorStatus(user?.status)}>
              <Text fontFamily={'JioType-Bold'} color={'WHITE'} fontSize={12}>
                {user?.status === 'TERMINATED' ? 'DELETED' : user?.status}
              </Text>
            </Box>
          </Box>
          <Spacer size={32} direction="vertical" />
          <Box height={1} bg={convertHexToRGBA('#000', 12) as ColorOptions} />
          <Spacer size={24} direction="vertical" />

          <UserDetailList item={userData} />

          <Spacer size={32} direction="vertical" />
          <Box
            borderRadius={8}
            borderWidth={1}
            borderColor={convertHexToRGBA(Colors.PRIMARY, 24) as ColorOptions}
            pv={16}
            ph={15}
            backgroundColor={convertHexToRGBA(Colors.PRIMARY, 4) as ColorOptions}>
            <Text
              fontFamily={'JioType-Bold'}
              color={Colors.BLACK_14 as ColorOptions}
              fontSize={14}
              lineHeight={24}
              letterSpacing={-0.07}>
              Permissions
            </Text>
            <Spacer direction="vertical" size={14} />
            <Box flexDirection={'row'} flexWrap={'wrap'}>
              {userOptedAccessRights?.map((item: any, index: number) => {
                return (
                  <Box key={index} width={'50%'} flexDirection="row" pv={8}>
                    <SvgImage imageName={isAnyChecked(item.data) ? 'ItemChecked' : 'ItemUnChecked'} />
                    <Spacer size={5} direction="horizontal" />
                    <Text fontFamily={'JioType-Medium'} color={Colors.BLACK_14 as ColorOptions} fontSize={12}>
                      {item.type.toLowerCase() !== 'null' ? item.type : 'Miscellaneous'}
                    </Text>
                  </Box>
                )
              })}
            </Box>
          </Box>
          <Spacer direction="vertical" size={50} />
        </ModBox>

        <ModalDialogNew animate={true} show={showModal} type="bottom" backgroundColor="TRANSPARENT">
          <Delete onPressItem={handleAction} status={userData.status} onDissMiss={() => setShowModal(false)} />
        </ModalDialogNew>

        <ModelBlockUser
          show={showBlockUserModel}
          onDismiss={onDissMiss}
          onPressDone={blockUser}
          data={userData}
          action={action}
          isLoading={deleteUserHandler.state === 'pending' || blockUnblockUserHandler.state === 'pending'}
          status={successAction}
        />
      </ScrollView>
    </Box>
  )
  }
  
}

const styles = {
  listWrapper: {
    backgroundColor: '#fff',
    padding: 25,
    paddingTop: 35,
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    width: '100%',
    marginTop: 70,
    flex: 1,
    zIndex: 4,
    // overflow: 'auto',
  } as ViewProps,
  textColorStatus: (status: any) =>
    ({
      bg:
        status === 'ACTIVE'
          ? ('#00B259' as ColorOptions)
          : status === 'BLOCKED'
          ? ('#FA7D19' as ColorOptions)
          : status === 'DELETED' || status === 'TERMINATED'
          ? ('#E30513' as ColorOptions)
          : 'TEXT_PENDING',
    } as BoxProps),
  scaleEdit: {
    transform: [{ scale: 1.4 }],
  } as ViewProps,
}

export default ViewUserDetail
